export default __webpack_public_path__ + "static/security-privacy-a6239f1f084a9d0a0699e641cbd83143.webp";